var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "\\u5716\\u5C64_1",
    width: "200px",
    height: "200px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      width: "100%",
      height: "100%",
      backgroundSize: "initial",
      backgroundRepeatY: "initial",
      backgroundRepeatX: "initial",
      backgroundPositionY: "initial",
      backgroundPositionX: "initial",
      backgroundOrigin: "initial",
      backgroundImage: "initial",
      backgroundColor: "rgb(255, 255, 255)",
      backgroundClip: "initial",
      backgroundAttachment: "initial",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)",
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    strokeMiterlimit: 10,
    strokeWidth: 8,
    stroke: "#333",
    fill: "none",
    r: 40,
    cy: 50,
    cx: 50,
    style: {
      stroke: "rgb(87, 65, 217)",
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#abbd81",
    d: "M47.3 66.4L73.7 40c1.8-1.8 1.8-4.6 0-6.4-1.8-1.8-4.6-1.8-6.4 0L44.1 56.8 32.7 45.4c-1.8-1.8-4.6-1.8-6.4 0-1.8 1.8-1.8 4.6 0 6.4l14.6 14.6c.9.9 2 1.3 3.2 1.3s2.3-.5 3.2-1.3z",
    style: {
      fill: "rgb(87, 65, 217)",
      animationPlayState: "paused"
    }
  })), /*#__PURE__*/React.createElement("metadata", {
    xmlnsD: "https://loading.io/stock/",
    style: {
      animationPlayState: "paused"
    }
  }, /*#__PURE__*/React.createElement("dName", {
    style: {
      animationPlayState: "paused"
    }
  }, "ok"), /*#__PURE__*/React.createElement("dTags", {
    style: {
      animationPlayState: "paused"
    }
  }, "ok,confirm,ready,positive,check,right,correct,affirmative,success"), /*#__PURE__*/React.createElement("dLicense", {
    style: {
      animationPlayState: "paused"
    }
  }, "by"), /*#__PURE__*/React.createElement("dSlug", {
    style: {
      animationPlayState: "paused"
    }
  }, "1s9wfp"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.13d92772dc8695a0a4983578f6c824ac.svg";
export { ForwardRef as ReactComponent };